module.exports = __webpack_public_path__ + "img/22.4704ef43.png";